module.exports = __webpack_public_path__ + "img/banner_img.020b60c9.png";